import useWebsiteRole from './useWebsiteRole'

export default function useWebsiteRoleStoresIds() {
  const myRole = useWebsiteRole()

  if (!myRole || !myRole.storesIds || !myRole.storesIds.length) return null

  return myRole.storesIds
}
